import actions from './actions';
import getters from './getters';
import mutations from './mutations';


const state = {
   
    data: {
        id:null,
        name:'',
        entity_id:null,
        original_name:'',
        serverpath:'',
        path:'',
        highlight:0,
        default:0

    },

    logos:[],                
    
};

export default {
  namespaced: true,
 
  state,
  actions,
  getters,
  mutations,
};